import React from "react";
import { prefixFactory } from "../utils";
import "./index.less";

export const CatalogView = ({ style, catalog, minLevel }) => {
  const factory = prefixFactory(style, minLevel);
  const links = catalog.map(({ key, level, text, scrollIntoView }) => {
    const indent = level - minLevel;
    const prefix = factory(level);

    return (
      <div key={key} className={`indent-${indent} link-wrapper`}>
        {prefix}
        <a className="link" onClick={scrollIntoView}>
          {text}
        </a>
      </div>
    );
  });

  return (
    <div className="ct-catalog-view">
      <div className="title">目录</div>
      {links}
    </div>
  );
};
